$(function () {
  /**
   * サブミット時のバリデーション
   * @param  {[type]} e [description]
   * @return {[type]}   [description]
   */
  $('.js-validateSubmit').on('click', function (e) {
    const target = $(e.currentTarget);
    $('.error').length;
    $('.error').remove();
    let error_count = 0;
    const validateTarget = target.parents('.js-form').find('.js-validate');
    $.each(validateTarget, function (i, x) {
      switch ($(x).attr('name')) {
        case 'company_name':
        case 'department_name':
        case 'manager_name':
          const requiredBox = required(x);
          if(requiredBox) {
            $(x).parent().append(`<p class="error">※${$(x).attr('data-valiName')}は${requiredBox}</p>`);
            error_count++;
          } else {
            $(x).siblings('.error').remove();
          }
          break;
        case 'company_furi':
          if($(x).val()) {
            const furiganaVali = furigana(x);
            $(x).siblings('.error').remove();
            if(furiganaVali) {
              $(x).after(`<p class="error">※${$(x).attr('data-valiName')}は${furiganaVali}</p>`);
              error_count++;
            } else {
              $(x).siblings('.error').remove();
            }
          } else {
            $(x).siblings('.error').remove();
            const furiganaValiBox = required(x);
            if(furiganaValiBox) {
              $(x).after(`<p class="error">※${$(x).attr('data-valiName')}は${furiganaValiBox}</p>`);
              error_count++;
            } else {
              $(x).siblings('.error').remove();
            }
          }
          break;
        case 'tel':
          if($(x).val()) {
            const telBox = tel(x);
            $(x).siblings('.error').remove();
            if(telBox) {
              $(x).after(`<p class="error">※${telBox}</p>`)
              error_count++;
            } else {
              $(x).siblings('.error').remove();
            }
          } else {
            const numberVali = required(x);
            $(x).siblings('.error').remove();
            if(numberVali) {
              $(x).after(`<p class="error">※${$(x).attr('data-valiName')}は${numberVali}</p>`);
              error_count++;
            } else {
              $(x).siblings('.error').remove();
            }
          }
          break;
        case 'email':
          if($(x).val()) {
            const mailBox = mail(x);
            if (mailBox) {
              $(x).after(`<p class="error">※${mailBox}</p>`);
              error_count++;
            } else {
              $(x).siblings('.error').remove();
            }
          } else {
            const mailVali = required(x);
            $(x).siblings('.error').remove();
            if(mailVali) {
              $(x).after(`<p class="error">※${$(x).attr('data-valiName')}は${mailVali}</p>`);
              error_count++;
            } else {
              $(x).siblings('.error').remove();
            }
          }
          break;
      }
    });

    if (error_count > 0) {
      return false;
    } else {
      return true;
    }
  });

  /**
   * 空判定のバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
  function required(target) {
    let error = '';
    if(!$(target).val()) {
      return error = '必須項目です。';
    }
  }

  /**
   * フリガナのバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
  function furigana(target) {
    let error = '';
    if(!$(target).val().match(/^[ァ-ヶー　]*$/)) {
      return error = 'カタカナで入力してください。';
    }
  }

  /**
   * 電話番号のバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
  function tel(target) {
    let error = '';
    // if (!$(target).val().match(/^0\d{1,4}-\d{1,4}-\d{3,4}$|^\d{9,13}$/)) {
    if (!$(target).val().match(/^\d{9,13}$/)) {
    return error = '電話番号に誤りがあります。';
    }
  }

    /**
   * メールのバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
    function mail(target) {
      let error = '';
      if (!$(target).val().match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
        return error = 'メールアドレスに誤りがあります。';
      }
    }
});